<template lang="pug">
.send-request-rplies-tab
  .mb-3

  //- 受け入れ可
  b-card.mb-2(no-body v-if="_replyAcceptance == true")
    b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle="'accordion-possible'")
      .toggle-text.pl-2 受け入れ可（{{ replies.possibleItems.length }}件）
    b-collapse(id="accordion-possible" accordion="accordion-possible" role="tabpanel" @shown="onCollapseShown('accordion-possible')")
      b-card-body.p-1
        .item-row.d-flex.flex-row.align-items-start.mb-1(v-for="(item, index) in replies.possibleItems")
          SendRequestReplyFacility.facility-info.mr-4(v-model="item.facility")
          .replies
            .messages.mb-2(v-if="item.firstReply || 0 < item.followUpReplies.length")
              .reply-message.mb-2(v-for="reply in [item.firstReply].concat(item.followUpReplies)")
                SendRequestReplyMessage(:value="reply")
            .buttons.d-flex.flex-column.align-items-end
              button.btn.reply-btn.mb-2(@click="onInputReply(item)") 返信

  //- 詳細確認希望
  b-card.mb-2(no-body v-if="_replyAcceptance == true")
    b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle="'accordion-need-consultation'")
      .toggle-text.pl-2 詳細確認希望（{{ replies.needConsultationItems.length }}件）
    b-collapse(id="accordion-need-consultation" accordion="accordion-need-consultation" role="tabpanel" @shown="onCollapseShown('accordion-need-consultation')")
      b-card-body.p-1
        .item-row.d-flex.flex-row.align-items-start.mb-1(v-for="(item, index) in replies.needConsultationItems")
          SendRequestReplyFacility.facility-info.mr-4(v-model="item.facility")
          .replies
            .messages.mb-2(v-if="item.firstReply || 0 < item.followUpReplies.length")
              .reply-message.mb-2(v-for="reply in [item.firstReply].concat(item.followUpReplies)")
                SendRequestReplyMessage(:value="reply")
            .buttons.d-flex.flex-column.align-items-end
              button.btn.reply-btn.mb-2(@click="onInputReply(item)") 返信

  //- 受け入れ不可
  b-card.mb-2(no-body v-if="_replyAcceptance == true")
    b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle="'accordion-not-possible'")
      .toggle-text.pl-2 受け入れ不可（{{ replies.notPossibleItems.length }}件）
    b-collapse(id="accordion-not-possible" accordion="accordion-not-possible" role="tabpanel" @shown="onCollapseShown('accordion-not-possible')")
      b-card-body.p-1
        .item-row.d-flex.flex-row.align-items-start.mb-1(v-for="(item, index) in replies.notPossibleItems")
          SendRequestReplyFacility.facility-info.mr-4(v-model="item.facility")
          .replies
            .messages.mb-2(v-if="item.firstReply || 0 < item.followUpReplies.length")
              .reply-message.mb-2(v-for="reply in [item.firstReply].concat(item.followUpReplies)")
                SendRequestReplyMessage(:value="reply")
            .buttons.d-flex.flex-column.align-items-end
              button.btn.reply-btn.mb-2(@click="onInputReply(item)") 返信

  //- 返信済
  b-card.mb-2(no-body v-if="_replyAcceptance == false")
    b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle="'accordion-reply'")
      .toggle-text.pl-2 返信済（{{ replies.replyItems.length }}件）
    b-collapse(id="accordion-reply" accordion="accordion-reply" role="tabpanel" @shown="onCollapseShown('accordion-reply')")
      b-card-body.p-1
        .item-row.d-flex.flex-row.align-items-start.mb-1(v-for="(item, index) in replies.replyItems")
          SendRequestReplyFacility.facility-info.mr-4(v-model="item.facility")
          .replies
            .messages.mb-2(v-if="item.firstReply || 0 < item.followUpReplies.length")
              .reply-message.mb-2(v-for="reply in [item.firstReply].concat(item.followUpReplies)")
                SendRequestReplyMessage(:value="reply")
            .buttons.d-flex.flex-column.align-items-end
              button.btn.reply-btn.mb-2(@click="onInputReply(item)") 返信

  //- 未返信
  b-card.mb-2(no-body)
    b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle="'accordion-no-reply'")
      .toggle-text.pl-2 未返信（{{ replies.noReplyItems.length }}件）
    b-collapse(id="accordion-no-reply" accordion="accordion-no-reply" role="tabpanel")
      b-card-body.p-1
        .item-row.d-flex.flex-row.align-items-start.mb-1(v-for="(item, index) in replies.noReplyItems")
          SendRequestReplyFacility.facility-info.mr-4(v-model="item.facility")

  //- リクエスト返信入力モーダル
  RequestReplyInputModal(ref="requestReplyInputModal" v-model="showRequestReplyInputModal" :request="requestReplyInputModalTarget" @onReply="onModalReply")
  OkCancelModal(v-model="showRequestReplyRegisterModal" title="返信しますか？" @ok="sendRequestReply")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { OtherOfficeAcceptanceRequestsGetModel } from "@/commons/services/OtherOfficeAcceptanceRequests";
import { Acceptance, OtherOfficeAcceptanceRequestRepliesGetModel, OtherOfficeAcceptanceRequestRepliesPostModel } from "@/commons/services/OtherOfficeAcceptanceRequestReplies";

import SendRequestReplyFacility from "@/pc/components/otherOfficeRoomSchedules/SendRequestReplyFacility.vue";
import SendRequestReplyMessage from "@/pc/components/otherOfficeRoomSchedules/SendRequestReplyMessage.vue";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import RequestReplyInputModal from "@/pc/components/otherOfficeRoomSchedules/RequestReplyInputModal.vue";
/**
 * ### 送信タブコンポーネント
 */
@Component({
  components: {
    SendRequestReplyFacility,
    SendRequestReplyMessage,
    RequestReplyInputModal,
    OkCancelModal
  }
})
export default class SendRequestRepliesTab extends Vue {
  @Prop()
  request!: OtherOfficeAcceptanceRequestsGetModel;
  /** リクエスト返信（受け入れ可、詳細確認希望、受け入れ不可、返信済み、未返信に分ける） */
  @Prop()
  replies!: SendRequestRepliesModel;

  /** リクエスト返信入力モーダル表示可否 */
  showRequestReplyInputModal: boolean = false;
  /** リクエスト返信入力モーダルに渡す返信履歴 */
  requestReplyInputModalReplies: OtherOfficeAcceptanceRequestRepliesGetModel | null = null;
  /** リクエスト返信入力モーダルに渡すリクエスト */
  requestReplyInputModalTarget: OtherOfficeAcceptanceRequestRepliesGetModel | null = null;
  /** リクエスト返信登録情報 */
  otherOfficeAcceptanceRequestRepliesPostModel: OtherOfficeAcceptanceRequestRepliesPostModel | null = null;
  /** リクエスト返信登録確認モーダル表示可否 */
  showRequestReplyRegisterModal: boolean = false;

  get _replyAcceptance(): boolean {
    if (!this.request) {
      return false;
    }
    return this.request.replyAcceptance;
  }

  /**
   * ### アコーディオンが開いた時のイベント
   *
   * - メッセージエリアを最下部にスクロールする
   */
  onCollapseShown(id: string): void {
    const collapseElement = this.$el.querySelector(`#${id}`);
    if (collapseElement) {
      const messagesElements = collapseElement.querySelectorAll(".messages");
      for (let i = 0; i < messagesElements.length; i++) {
        messagesElements[i].scrollTo({
          top: messagesElements[i].scrollHeight, // スクロール位置、末尾を指定して移動させる
          behavior: "smooth" // smoothを使用して、スクロールを滑らかに移動させる
        });
      }
    }
    return;
  }

  /**
   * ### 返信入力ボタン押下処理
   */
  onInputReply(item: OtherOfficeAcceptanceRequestRepliesGetModel): void {
    this.showRequestReplyInputModal = true;
    this.requestReplyInputModalTarget = item;
    return;
  }

  /**
   * ### 返信入力モーダルの送信ボタン押下イベント
   */
  onModalReply(event: { acceptance: Acceptance | null; messageText: string }): void {
    const requestBody: OtherOfficeAcceptanceRequestRepliesPostModel = {
      parentKey: `${this.request.facilityId}_${this.request.datetime}`,
      acceptance: event.acceptance,
      messageText: event.messageText,
      // 自分で送信したリクエストへの返信なので、相手施設IDを設定する
      receiverFacilityId: this.requestReplyInputModalTarget?.facility!.id
    };
    this.otherOfficeAcceptanceRequestRepliesPostModel = requestBody;

    this.showRequestReplyRegisterModal = true;

    return;
  }

  /**
   * ### 返信確認モーダルでOKボタン押下イベント
   */
  sendRequestReply(): void {
    // 返信入力モーダルは自動でクローズされないので、ここで閉じる
    this.showRequestReplyInputModal = false;

    this.$emit("sendReply", this.otherOfficeAcceptanceRequestRepliesPostModel);
    return;
  }
}

export interface SendRequestRepliesModel {
  /** 受け入れ可 */
  possibleItems: Array<OtherOfficeAcceptanceRequestRepliesGetModel>;
  /** 詳細確認希望 */
  needConsultationItems: Array<OtherOfficeAcceptanceRequestRepliesGetModel>;
  /** 受け入れ不可 */
  notPossibleItems: Array<OtherOfficeAcceptanceRequestRepliesGetModel>;
  /** 返信済 */
  replyItems: Array<OtherOfficeAcceptanceRequestRepliesGetModel>;
  /** 未返信 */
  noReplyItems: Array<OtherOfficeAcceptanceRequestRepliesGetModel>;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.item-row {
  padding: 0.5rem;
  border: 1px solid $border-lightgray;

  .facility-info {
    min-width: 420px;
    max-width: 420px;
    width: 420px;
  }

  .replies {
    width: calc(100% - 420px);

    .messages {
      background-color: $bg-message;
      padding: 1rem;

      max-height: 380px;
      overflow-y: auto;
    }

    .reply-btn {
      margin: 0 !important;
    }
  }
}
</style>
